import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { setAuthProperty } from '../js/actions/index';
import { Container, Col, Row } from "react-bootstrap";

import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';

import I18N from "../js/i18n";

import {
    RESTAURANT, SUPPLIER
  } from "../constants/GlobalConstant";

var jwt = require("jsonwebtoken");

var METABASE_SITE_URL = "https://bi.agorahub.xyz";
var METABASE_SECRET_KEY = "02a228b915cfb435c6dbd1d7974e779aca29b28d215ed686f3ac14c4623aff0b";

function mapDispatchToProps(dispatch) {
    return {
      setAuthProperty: type => dispatch(setAuthProperty(type))
    };
}

class Home extends React.Component {
    render() {
    var payload = {
        resource: { dashboard: 4 },
        params: {
          "text": this.props.auth.supplierId
        },
        exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration
      };
      var token = jwt.sign(payload, METABASE_SECRET_KEY);
      
      var iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=false";
      
        return (
            <>
            <Container fluid className="p-0">
                <NavbarComponent />
                <Container>
                    <Row>
                        <Col xs={12}>
                            <div className="mt-4 text-center">
                                {/* <h1><I18N type="ui" path="CONSOLE" def="Console"/> - <I18N type="ui" path="AGORA_HUB" def="Agora Hub"/></h1> */}
                                <img src="/assets/images/logo_horus.png" width="auto" height="200px" alt="Horus" />
                            </div>
                        </Col>
                    </Row>
                    {this.props.auth.mode === SUPPLIER &&
                    <>
                    <Row><div height="80px">&nbsp;</div></Row>
                    <Row>
                    <iframe
                                src={iframeUrl}
                                frameBorder="0"
                                width="100%"
                                height="1024"
                                allowtransparency="true"
                            ></iframe>
                    </Row>
                    </>
                    }                    
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

//export default connect(mapStateToProps, null)(withRouter(Home));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));